import { motion } from "framer-motion";
import { fadeUp, viewport } from "@/lib/motion";
import { IMAGES } from "@/data";
import { useLang } from "@/context/LanguageContext";

export const About = () => {
  const { t } = useLang();
  const a = t.about;
  return (
    <section id="about" className="relative py-24 md:py-32 scroll-mt-20">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-5">
            <motion.p variants={fadeUp} initial="hidden" whileInView="show" viewport={viewport} className="overline text-[#C4A484] mb-6">{a.overline}</motion.p>
            <motion.h2 variants={fadeUp} initial="hidden" whileInView="show" viewport={viewport} custom={1} className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[0.95] tracking-tight text-[#0D2A27]">{a.heading}</motion.h2>
            <motion.div variants={fadeUp} initial="hidden" whileInView="show" viewport={viewport} custom={2} className="relative mt-10 h-[320px] overflow-hidden border border-[#E2E0D8]">
              <img src={IMAGES.consult} alt="Clinical consultation notes" className="h-full w-full object-cover" />
            </motion.div>
          </div>

          <div className="lg:col-span-7 lg:pl-10">
            <motion.p variants={fadeUp} initial="hidden" whileInView="show" viewport={viewport} className="text-lg md:text-xl text-[#555] leading-relaxed mb-14 max-w-xl">{a.para}</motion.p>

            <div className="divide-y divide-[#E2E0D8] border-t border-[#E2E0D8]">
              {a.chapters.map((c, i) => (
                <motion.div key={c.n} variants={fadeUp} custom={i} initial="hidden" whileInView="show" viewport={viewport} className="group grid grid-cols-[auto_1fr] gap-6 md:gap-10 py-8 items-start">
                  <span className="font-serif text-2xl text-[#C4A484]">{c.n}</span>
                  <div>
                    <h3 className="font-serif text-2xl md:text-3xl text-[#0D2A27] transition-transform duration-300 group-hover:translate-x-1">{c.title}</h3>
                    <p className="mt-3 text-[#555] leading-relaxed max-w-lg">{c.text}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
